export enum AmbivalentFactorEffectCategoryEnum {
  Alleviating = 'Alleviating',
  Aggravating = 'Aggravating',
  Ambivalent = 'Ambivalent',
}
